import { DocumentsClient } from '@src/documents/services/DocumentsClient';
import type { Document } from '@src/orders/domain/PermitApplication';
import { useMutation } from '@tanstack/react-query';

export const useUploadDocument = ({
  permitId,
  orderId,
  onSuccess,
  onError,
  sendToClient,
}: {
  permitId?: string;
  orderId: string;
  onSuccess: (newDocument: Document) => void;
  onError: () => void;
  sendToClient?: boolean;
}) => {
  const { mutate, isPending } = useMutation({
    mutationFn: (file: File) =>
      DocumentsClient.upload({
        file,
        permitApplicationId: permitId,
        orderId,
        sendToClient,
      }),
    onSuccess: (newDocument: Document) => onSuccess(newDocument),
    onError,
  });

  return {
    uploadDocument: mutate,
    isPending,
  };
};
